<template>
  <div style="position:relative">
    <div class="group-top">
      <p class="p-40">充值专享优惠 全面保护版权</p>
      <img src="./images/bg1.png" class="img-top" />
    </div>
    <div class="group-menu">
      <ul>
        <li @click="openItem(1)" :style="{borderBottom:currentIndex==1?'1px solid #E82E31':'1px solid #EEEEEE'}">
          <img :src="currentIndex==1?certYes:certNo" />
          <div>
            <p class="p-18">基于版权区块链的存证</p>
            <p class="p-14">数据直通互联网法院</p>
          </div>
        </li>
        <li @click="openItem(2)" :style="{borderBottom:currentIndex==2?'1px solid #E82E31':'1px solid #EEEEEE'}">
          <img :src="currentIndex==2?dciYes:dciNo" style="width:64px;height:56px;" />
          <div>
            <p class="p-18">作品登记证书</p>
            <p class="p-14">由国家版权局统一监制，贵州版权局审核下发</p>
          </div>
        </li>
      </ul>
    </div>
    <div>
      <groupDci></groupDci>
    </div>
  </div>
</template>

<script>
import groupDci from './groupDci.vue'
export default {
  metaInfo: {
      title: '存证登记|时尚知识产权保护平台',
      meta: [{                 // set meta
          name: 'keyWords',
          content: ''
      },{
          name: 'Description',
          content: ''
      }]
  },
  name: "groupIntroduce", 
  components:{
    groupDci
  },
  data(){
    return{            
     currentIndex:1,
     certYes:require('./images/cert-yes.png'),
     certNo:require('./images/cert-no.png'),
     dciYes:require('./images/dci-yes.png'),
     dciNo:require('./images/dci-no.png'),

    }
  },
  methods:{
    openItem(val){
      this.currentIndex=val
    }
  }
       
};
</script>

<style scoped lang="less">
.group-top{
  min-width: 1334px;
  height:360px;
  background:rgba(18,18,16,1);
  text-align: center;
  overflow: hidden;
  .p-40{
    font-size:40px;
    font-weight:bold;
    color:rgba(255,255,255,1);
    letter-spacing:2px;
    margin-top:98px;
  }
  .img-top{
    width:621px;
    height: 68px;
    position: relative;
    top:-30px;
  }
}
.group-menu{
  width:1334px;
  height: 113px;
  background: #fff;
  margin:0 auto;
  position: absolute;
  top:247px;
  left:0;
  right:0;
  ul{
    overflow: hidden;
    height: 99px;
    width:1334px;
    li{
      float: left;
      list-style: none;
      width: 667px;
      height: 99px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #EEEEEE;
      cursor: pointer;
      img{
        width:55px;
        height: 59px;
        margin:0 32px 0 34px;
      }
      .p-18{
        font-size:18px;
        font-weight:400;
        color:rgba(18,16,0,1);
        letter-spacing:1px;
        margin-bottom: 5px;
      }
      .p-14{
        font-size:14px;
        font-weight:400;
        color:rgba(18,16,0,1);
      }
    }
  }
}
</style>
